<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Prévia do documento antes da publicação."
    closeAriaLabel="Fechar"
    header="Minuta da Ata"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: 'min(900px, 95vw)', border: 'none' }"
    styleClass="dialogo-preview-ata"
    appendTo="body"
    (onHide)="fechar()"
>
    <div class="preview-ata-toggle flex gap-2 pb-2">
        <button type="button" pButton label="Minuta" icon="pi pi-file-edit" [outlined]="tipo() !== 'minuta'" (click)="selecionarTipo.emit('minuta')"></button>
        <button type="button" pButton label="Ata" icon="pi pi-file" [outlined]="tipo() !== 'ata'" (click)="selecionarTipo.emit('ata')"></button>
    </div>
    <iframe class="preview-ata-frame" title="Pré-visualização da ata" sandbox="allow-same-origin" [srcdoc]="documentoSafe()" style="width: 100%; height: 70vh; border: 1px solid #e5e7eb"></iframe>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Fechar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
        </div>
    </ng-template>
</p-dialog>
